import merge from '@/utils/merge-objects'

const requiredTranslation = require.context('.', true, /\.json$/)

const translationFiles = [
  'portfolio-builder.json',
  'advice.json',
  'account.json',
  'advisory.json',
  'allocation.json',
  'analyse.json',
  'api-values.json',
  'arbitration.json',
  'club.json',
  'common.json',
  'contract.json',
  'dashboard.json',
  'fund.json',
  'interaction.json',
  'loan.json',
  'mission.json',
  'project.json',
  'real-estate.json',
  'subscription.json',
  'toast.json',
  'user.json',
  'pdf.json',
  'toast-errors.json',
  'overview.json',
  'welcome-page.json'
]

const removeFalseValue = (obj) => {
  const objCloned = JSON.parse(JSON.stringify(obj))

  for (const key in objCloned) {
    if (objCloned[key] === false) {
      delete objCloned[key]
    } else if (typeof objCloned[key] === 'object' && objCloned[key] !== null) {
      objCloned[key] = removeFalseValue(objCloned[key]);

      if (Object.keys(objCloned[key]).length === 0) {
        delete objCloned[key]
      }
    }
  }

  return objCloned
}

const getFileContent = (fileLink) => {
  try {
    return requiredTranslation(fileLink)
  } catch (e) {
    return {}
  }
}

let results = {}

for (const file of translationFiles) {
  const globalTranslation = getFileContent(`./${file}`)
  const specificTranslation = getFileContent(`./${process.env.APP_ID}/${file}`)

  // suppress false values to suppress keys in the final translation, certain parts of the code are conditioned according to the presence of a translation 
  const mergeTranslatation = removeFalseValue(merge(globalTranslation, specificTranslation))
  results = Object.assign(results, mergeTranslatation)
}

const languagePack = Object.assign(
  {},
  results,
  require('../brandnames.json')
)

export {
  languagePack
}
